import * as React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import '@scss/main.scss';
import { store, history } from '@core/redux';
import { PassportContextProvider, PassportEnums } from '@tti/passport';
import AppRouter from '@components/routing/AppRouter';

const App: React.FC = () => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <PassportContextProvider siteID={PassportEnums.Site.FactTagGenerator}>
        <AppRouter />
      </PassportContextProvider>
    </ConnectedRouter>
  </Provider>
);

export default App;
